import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  VStack,
  Heading,
  Text,
  Button,
  useColorModeValue,
  Container,
  Divider,
  HStack,
  Icon,
  ButtonGroup,
} from '@chakra-ui/react';
import { FaPrint } from 'react-icons/fa';
import Barcode from 'react-barcode';
import { CheckCircleIcon } from '@chakra-ui/icons';
import { useEffect } from 'react';

interface SummaryData {
  expediente: string;
  tipoBarrera: string;
  nombreApellidos: string;
  localidad: string;
  provincia: string;
  email: string;
}

export const SubmissionSummary = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const summaryData = location.state as SummaryData;
  const brandRed = useColorModeValue('red.500', 'red.300');

  useEffect(() => {
    if (!summaryData) {
      navigate('/');
    }
  }, [summaryData, navigate]);

  const handleContinue = () => {
    navigate('/');
  };

  const handlePrint = () => {
    window.print();
  };

  const handleConsulta = () => {
    navigate('/consulta-expediente', {
      state: {
        expediente: summaryData.expediente,
        email: summaryData.email
      }
    });
  };

  if (!summaryData) return null;

  return (
    <Box
      minH="100vh"
      py={10}
      backgroundImage="url('/silla.jpg')"
      backgroundSize="cover"
      backgroundPosition="center"
      position="relative"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="whiteAlpha.900"
      />
      <Container maxW="container.md" position="relative" zIndex={1}>
        <VStack
          spacing={8}
          bg="white"
          p={8}
          borderRadius="xl"
          boxShadow="xl"
          align="stretch"
        >
          <VStack spacing={4}>
            <Icon as={CheckCircleIcon} w={16} h={16} color="green.500" />
            <Heading size="xl" color={brandRed} textAlign="center">
              ¡Denuncia Registrada con Éxito!
            </Heading>
          </VStack>

          <Divider />

          <Box bg="gray.50" p={6} borderRadius="lg">
            <VStack spacing={6} align="center">
              <Text fontSize="lg" fontWeight="bold" color="gray.700">
                Número de Expediente
              </Text>
              <Text fontSize="2xl" fontWeight="bold" color={brandRed}>
                {summaryData.expediente}
              </Text>
              <Box>
                <Barcode value={summaryData.expediente} />
              </Box>
              <Text fontSize="sm" color="gray.600">
                Guarda este número y tu email ({summaryData.email}) para consultar el estado de tu denuncia
              </Text>
            </VStack>
          </Box>

          <VStack spacing={4} align="stretch" bg="gray.50" p={6} borderRadius="lg">
            <HStack justify="space-between">
              <Text fontWeight="bold">Tipo de Barrera:</Text>
              <Text>{summaryData.tipoBarrera}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontWeight="bold">Solicitante:</Text>
              <Text>{summaryData.nombreApellidos}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontWeight="bold">Localidad:</Text>
              <Text>{summaryData.localidad}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontWeight="bold">Provincia:</Text>
              <Text>{summaryData.provincia}</Text>
            </HStack>
            <HStack justify="space-between">
              <Text fontWeight="bold">Email:</Text>
              <Text>{summaryData.email}</Text>
            </HStack>
          </VStack>

          <style>
            {`
              @media print {
                .no-print {
                  display: none !important;
                }
              }
            `}
          </style>
          <ButtonGroup width="100%" spacing={4} className="no-print">
            <Button
              colorScheme="red"
              size="lg"
              onClick={handleConsulta}
              flex={1}
            >
              Consultar Estado
            </Button>
            <Button
              colorScheme="gray"
              size="lg"
              onClick={handleContinue}
              flex={1}
            >
              Volver al Inicio
            </Button>
            <Button
              leftIcon={<Icon as={FaPrint} />}
              colorScheme="blue"
              size="lg"
              onClick={handlePrint}
              flex={1}
            >
              Imprimir
            </Button>
          </ButtonGroup>
        </VStack>
      </Container>
    </Box>
  );
};
